import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addStep,
  allSteps,
  updateStep,
  deleteStep,
  removeLayerConfig,
  changeStepOrder
} from '../../../redux/stepsSlice';
import {
  setActiveStep,
  getActiveStep,
  removeActiveLayer
} from '../../../redux/toolsSlice';
import EditStepItem from './EditStepItem';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const StepSidebar = () => {
  const dispatch = useDispatch();
  const steps = useSelector((state) => allSteps(state));
  const activeStep = useSelector((state) => getActiveStep(state));
  const [editingStep, setEditingStep] = useState(null);
  const materialType = window?.location?.pathname?.split('/')?.[2];
  const activeIndex = steps.findIndex((step) => step.id === activeStep?.id);

  const handleNewStep = () => {
    dispatch(addStep({ material_type: materialType }));
  };

  const isActiveStep = (stepId) => {
    if (activeStep === undefined) return false;
    return activeStep.id === stepId;
  };

  const handleStepChange = (step) => {
    dispatch(setActiveStep(step));
    dispatch(removeActiveLayer());
    dispatch(removeLayerConfig());
  };

  const handleDoubleClick = (step) => {
    setEditingStep(step.id);
  };

  const handleEditChange = (e) => {
    const updatedStep = {
      ...activeStep,
      [e.target.name]: e.target.value
    };
    dispatch(updateStep(updatedStep));
  };

  const handleCancelEdit = () => {
    setEditingStep(null);
  };

  const handleRemoveStep = (stepId) => {
    dispatch(deleteStep(stepId));

    if (steps.length > 1) {
      const newActiveStep = steps.find((step) => step.id !== stepId);
      dispatch(setActiveStep(newActiveStep));
    }
  };

  const moveStep = (fromIndex, toIndex) => {
    dispatch(changeStepOrder({ fromIndex, toIndex }));
  };

  const renderSteps = () => {
    if (steps === undefined) return null;

    return steps.map((step, index) => {
      const isActive = isActiveStep(step.id);
      const className = `step-block ${isActive ? 'active' : ''}`;
      const statusLabel = isActive ? 'Currently active' : index < activeIndex ? 'Completed' : 'Pending';

      return (
        <div key={step.id} onClick={() => handleStepChange(step)} onDoubleClick={() => handleDoubleClick(step)}>
          <EditStepItem
            step={step}
            index={index}
            stepNumber={index + 1}
            statusLabel={statusLabel}
            className={className}
            edit={editingStep === step.id}
            material_type={materialType}
            handleEditChange={handleEditChange}
            handleCancelEdit={handleCancelEdit}
            handleRemoveStep={handleRemoveStep}
            moveStep={moveStep}
          />
        </div>
      );
    });
  };

  useEffect(() => {
    if (steps === undefined || steps.length === 0) return;
    dispatch(setActiveStep(steps[0]));
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="un-steps-sidebar">
        <div className="un-header">
          <div>
            <p className="un-header__eyebrow">Path Steps</p>
            <span className="un-header__hint">Preview and organize the onboarding flow.</span>
          </div>
        </div>
        <div className="body">{renderSteps()}</div>
        <div className="un-steps-sidebar__footer">
          <button type="button" className="un-steps-sidebar__add" onClick={handleNewStep}>
            + Add Step
          </button>
        </div>
      </div>
    </DndProvider>
  );
};

export default StepSidebar;
